import React from "react";
import { QRCodeCanvas } from "qrcode.react";

const QRCodeScanner = ({
  url,
  size = 200,
  bgColor = "#ffffff",
  fgColor = "#000000",
  level = "L",
}) => {
  return (
    <QRCodeCanvas
      value={url}
      size={size}
      bgColor={bgColor}
      fgColor={fgColor}
      level={level}
    />
  );
};

export default QRCodeScanner;
